[
  {
    "id": "regular_decoration_tier1",
    "item_type": "decoration",
    "tier": 1,
    "tags_include": [],
    "tags_exclude": ["no_gacha", "event_gacha_only"]
  },
  {
    "id": "regular_decoration_tier2",
    "item_type": "decoration",
    "tier": 2,
    "tags_include": [],
    "tags_exclude": ["no_gacha", "event_gacha_only"]
  },
  {
    "id": "regular_decoration_tier3",
    "item_type": "decoration",
    "tier": 3,
    "tags_include": [],
    "tags_exclude": ["no_gacha", "event_gacha_only"]
  },
  {
    "id": "regular_accessory_tier1",
    "item_type": "accessory",
    "tier": 1,
    "tags_include": [],
    "tags_exclude": ["no_gacha", "event_gacha_only"]
  },
  {
    "id": "regular_accessory_tier2",
    "item_type": "accessory",
    "tier": 2,
    "tags_include": [],
    "tags_exclude": ["no_gacha", "event_gacha_only"]
  },
  {
    "id": "regular_accessory_tier3",
    "item_type": "accessory",
    "tier": 3,
    "tags_include": [],
    "tags_exclude": ["no_gacha", "event_gacha_only"]
  },
  {
    "id": "e0001_valentine_tier1",
    "item_type": "decoration",
    "tier": 1,
    "tags_include": ["09_valentine_day"],
    "tags_exclude": ["no_gacha"]
  },
  {
    "id": "e0001_valentine_tier2",
    "item_type": "decoration",
    "tier": 2,
    "tags_include": ["09_valentine_day"],
    "tags_exclude": ["no_gacha"]
  },
  {
    "id": "e0001_valentine_tier3",
    "item_type": "decoration",
    "tier": 3,
    "tags_include": ["09_valentine_day"],
    "tags_exclude": ["no_gacha"]
  },
  {
    "id": "e0001_valentine_tier4",
    "item_type": "decoration",
    "tier": 4,
    "tags_include": ["09_valentine_day"],
    "tags_exclude": ["no_gacha"]
  },
  {
    "id": "e0003_decoratoin_tier1",
    "item_type": "decoration",
    "tier": 1,
    "tags_include": ["10_angel"],
    "tags_exclude": ["no_gacha"]
  },
  {
    "id": "e0003_decoratoin_tier2",
    "item_type": "decoration",
    "tier": 2,
    "tags_include": ["10_angel"],
    "tags_exclude": ["no_gacha"]
  },
  {
    "id": "e0003_decoratoin_tier3",
    "item_type": "decoration",
    "tier": 3,
    "tags_include": ["10_angel"],
    "tags_exclude": ["no_gacha"]
  },
  {
    "id": "e0003_decoratoin_tier4",
    "item_type": "decoration",
    "tier": 4,
    "tags_include": ["10_angel"],
    "tags_exclude": ["no_gacha"]
  },
  {
    "id": "e0003_accessory_tier1",
    "item_type": "accessory",
    "tier": 1,
    "tags_include": ["006_angel"],
    "tags_exclude": ["no_gacha"]
  },
  {
    "id": "e0003_accessory_tier2",
    "item_type": "accessory",
    "tier": 2,
    "tags_include": ["006_angel"],
    "tags_exclude": ["no_gacha"]
  },
  {
    "id": "e0003_accessory_tier3",
    "item_type": "accessory",
    "tier": 3,
    "tags_include": ["006_angel"],
    "tags_exclude": ["no_gacha"]
  },
  {
    "id": "e0003_accessory_tier4",
    "item_type": "accessory",
    "tier": 4,
    "tags_include": ["006_angel"],
    "tags_exclude": ["no_gacha"]
  },
  {
    "id": "hinamatsuri_a1_tier1",
    "item_type": "decoration",
    "tier": 1,
    "tags_include": ["12_hinamatsuri_a1"],
    "tags_exclude": ["no_gacha"]
  },
  {
    "id": "hinamatsuri_a1_tier2",
    "item_type": "decoration",
    "tier": 2,
    "tags_include": ["12_hinamatsuri_a1"],
    "tags_exclude": ["no_gacha"]
  },
  {
    "id": "hinamatsuri_a1_tier3",
    "item_type": "decoration",
    "tier": 3,
    "tags_include": ["12_hinamatsuri_a1"],
    "tags_exclude": ["no_gacha"]
  },
  {
    "id": "hinamatsuri_a1_tier4",
    "item_type": "decoration",
    "tier": 4,
    "tags_include": ["12_hinamatsuri_a1"],
    "tags_exclude": ["no_gacha"]
  },
  {
    "id": "hinamatsuri_a2_tier1",
    "item_type": "decoration",
    "tier": 1,
    "tags_include": ["13_hinamatsuri_a2"],
    "tags_exclude": ["no_gacha"]
  },
  {
    "id": "hinamatsuri_a2_tier2",
    "item_type": "decoration",
    "tier": 2,
    "tags_include": ["13_hinamatsuri_a2"],
    "tags_exclude": ["no_gacha"]
  },
  {
    "id": "hinamatsuri_a2_tier3",
    "item_type": "decoration",
    "tier": 3,
    "tags_include": ["13_hinamatsuri_a2"],
    "tags_exclude": ["no_gacha"]
  },
  {
    "id": "hinamatsuri_a2_tier4",
    "item_type": "decoration",
    "tier": 4,
    "tags_include": ["13_hinamatsuri_a2"],
    "tags_exclude": ["no_gacha"]
  },
  {
    "id": "whiteday_decoration_tier1",
    "item_type": "decoration",
    "tier": 1,
    "tags_include": ["14_whiteday"],
    "tags_exclude": ["no_gacha"]
  },
  {
    "id": "whiteday_decoration_tier2",
    "item_type": "decoration",
    "tier": 2,
    "tags_include": ["14_whiteday"],
    "tags_exclude": ["no_gacha"]
  },
  {
    "id": "whiteday_decoration_tier3",
    "item_type": "decoration",
    "tier": 3,
    "tags_include": ["14_whiteday"],
    "tags_exclude": ["no_gacha"]
  },
  {
    "id": "whiteday_decoration_tier4",
    "item_type": "decoration",
    "tier": 4,
    "tags_include": ["14_whiteday"],
    "tags_exclude": ["no_gacha"]
  },
  {
    "id": "whiteday_accessory_tier1",
    "item_type": "accessory",
    "tier": 1,
    "tags_include": ["008_whiteday"],
    "tags_exclude": ["no_gacha"]
  },
  {
    "id": "whiteday_accessory_tier2",
    "item_type": "accessory",
    "tier": 2,
    "tags_include": ["008_whiteday"],
    "tags_exclude": ["no_gacha"]
  },
  {
    "id": "whiteday_accessory_tier3",
    "item_type": "accessory",
    "tier": 3,
    "tags_include": ["008_whiteday"],
    "tags_exclude": ["no_gacha"]
  },
  {
    "id": "whiteday_accessory_tier4",
    "item_type": "accessory",
    "tier": 4,
    "tags_include": ["008_whiteday"],
    "tags_exclude": ["no_gacha"]
  },
  {
    "id": "2024gw_decoration_tier1",
    "item_type": "decoration",
    "tier": 1,
    "tags_include": ["19_circus"],
    "tags_exclude": ["no_gacha"]
  },
  {
    "id": "2024gw_decoration_tier2",
    "item_type": "decoration",
    "tier": 2,
    "tags_include": ["19_circus"],
    "tags_exclude": ["no_gacha"]
  },
  {
    "id": "2024gw_decoration_tier3",
    "item_type": "decoration",
    "tier": 3,
    "tags_include": ["19_circus"],
    "tags_exclude": ["no_gacha"]
  },
  {
    "id": "space_decoration_tier1",
    "item_type": "decoration",
    "tier": 1,
    "tags_include": ["20_space"],
    "tags_exclude": ["no_gacha"]
  },
  {
    "id": "space_decoration_tier2",
    "item_type": "decoration",
    "tier": 2,
    "tags_include": ["20_space"],
    "tags_exclude": ["no_gacha"]
  },
  {
    "id": "space_decoration_tier3",
    "item_type": "decoration",
    "tier": 3,
    "tags_include": ["20_space"],
    "tags_exclude": ["no_gacha"]
  },
  {
    "id": "egyptian_decoration_tier1",
    "item_type": "decoration",
    "tier": 1,
    "tags_include": ["21_egyptian"],
    "tags_exclude": ["no_gacha"]
  },
  {
    "id": "egyptian_decoration_tier2",
    "item_type": "decoration",
    "tier": 2,
    "tags_include": ["21_egyptian"],
    "tags_exclude": ["no_gacha"]
  },
  {
    "id": "egyptian_decoration_tier3",
    "item_type": "decoration",
    "tier": 3,
    "tags_include": ["21_egyptian"],
    "tags_exclude": ["no_gacha"]
  },
  {
    "id": "fruitsandcream_decoration_tier1",
    "item_type": "decoration",
    "tier": 1,
    "tags_include": ["22_fruitsandcream"],
    "tags_exclude": ["no_gacha"]
  },
  {
    "id": "fruitsandcream_decoration_tier2",
    "item_type": "decoration",
    "tier": 2,
    "tags_include": ["22_fruitsandcream"],
    "tags_exclude": ["no_gacha"]
  },
  {
    "id": "fruitsandcream_decoration_tier3",
    "item_type": "decoration",
    "tier": 3,
    "tags_include": ["22_fruitsandcream"],
    "tags_exclude": ["no_gacha"]
  },
  {
    "id": "halloween2024_decoration_tier1",
    "item_type": "decoration",
    "tier": 1,
    "tags_include": ["23_halloween2024"],
    "tags_exclude": ["no_gacha"]
  },
  {
    "id": "halloween2024_decoration_tier2",
    "item_type": "decoration",
    "tier": 2,
    "tags_include": ["23_halloween2024"],
    "tags_exclude": ["no_gacha"]
  },
  {
    "id": "halloween2024_decoration_tier3",
    "item_type": "decoration",
    "tier": 3,
    "tags_include": ["23_halloween2024"],
    "tags_exclude": ["no_gacha"]
  },
  {
    "id": "moonviewing_decoration_tier1",
    "item_type": "decoration",
    "tier": 1,
    "tags_include": ["24_moonviewing"],
    "tags_exclude": ["no_gacha"]
  },
  {
    "id": "moonviewing_decoration_tier2",
    "item_type": "decoration",
    "tier": 2,
    "tags_include": ["24_moonviewing"],
    "tags_exclude": ["no_gacha"]
  },
  {
    "id": "moonviewing_decoration_tier3",
    "item_type": "decoration",
    "tier": 3,
    "tags_include": ["24_moonviewing"],
    "tags_exclude": ["no_gacha"]
  },
  {
    "id": "cute_xmas_decoration_tier1",
    "item_type": "decoration",
    "tier": 1,
    "tags_include": ["25_cute_xmas"],
    "tags_exclude": ["no_gacha"]
  },
  {
    "id": "cute_xmas_decoration_tier2",
    "item_type": "decoration",
    "tier": 2,
    "tags_include": ["25_cute_xmas"],
    "tags_exclude": ["no_gacha"]
  },
  {
    "id": "cute_xmas_decoration_tier3",
    "item_type": "decoration",
    "tier": 3,
    "tags_include": ["25_cute_xmas"],
    "tags_exclude": ["no_gacha"]
  },
  {
    "id": "new_year_2025_decoration_tier1",
    "item_type": "decoration",
    "tier": 1,
    "tags_include": ["26_new_year_2025"],
    "tags_exclude": ["no_gacha"]
  },
  {
    "id": "new_year_2025_decoration_tier2",
    "item_type": "decoration",
    "tier": 2,
    "tags_include": ["26_new_year_2025"],
    "tags_exclude": ["no_gacha"]
  },
  {
    "id": "new_year_2025_decoration_tier3",
    "item_type": "decoration",
    "tier": 3,
    "tags_include": ["26_new_year_2025"],
    "tags_exclude": ["no_gacha"]
  },
  {
    "id": "setsubun_decoration_tier1",
    "item_type": "decoration",
    "tier": 1,
    "tags_include": ["27_setsubun"],
    "tags_exclude": ["no_gacha"]
  },
  {
    "id": "setsubun_decoration_tier2",
    "item_type": "decoration",
    "tier": 2,
    "tags_include": ["27_setsubun"],
    "tags_exclude": ["no_gacha"]
  },
  {
    "id": "setsubun_decoration_tier3",
    "item_type": "decoration",
    "tier": 3,
    "tags_include": ["27_setsubun"],
    "tags_exclude": ["no_gacha"]
  },
  {
    "id": "cafe_decoration_tier1",
    "item_type": "decoration",
    "tier": 1,
    "tags_include": ["28_cafe"],
    "tags_exclude": ["no_gacha"]
  },
  {
    "id": "cafe_decoration_tier2",
    "item_type": "decoration",
    "tier": 2,
    "tags_include": ["28_cafe"],
    "tags_exclude": ["no_gacha"]
  },
  {
    "id": "cafe_decoration_tier3",
    "item_type": "decoration",
    "tier": 3,
    "tags_include": ["28_cafe"],
    "tags_exclude": ["no_gacha"]
  },
  {
    "id": "hanami_decoration_tier1",
    "item_type": "decoration",
    "tier": 1,
    "tags_include": ["29_hanami"],
    "tags_exclude": ["no_gacha"]
  },
  {
    "id": "hanami_decoration_tier2",
    "item_type": "decoration",
    "tier": 2,
    "tags_include": ["29_hanami"],
    "tags_exclude": ["no_gacha"]
  },
  {
    "id": "hanami_decoration_tier3",
    "item_type": "decoration",
    "tier": 3,
    "tags_include": ["29_hanami"],
    "tags_exclude": ["no_gacha"]
  },
  {
    "id": "childrens_day2025_decoration_tier1",
    "item_type": "decoration",
    "tier": 1,
    "tags_include": ["childrens_day2025"],
    "tags_exclude": ["no_gacha"]
  },
  {
    "id": "childrens_day2025_decoration_tier2",
    "item_type": "decoration",
    "tier": 2,
    "tags_include": ["childrens_day2025"],
    "tags_exclude": ["no_gacha"]
  },
  {
    "id": "childrens_day2025_decoration_tier3",
    "item_type": "decoration",
    "tier": 3,
    "tags_include": ["childrens_day2025"],
    "tags_exclude": ["no_gacha"]
  },
  {
    "id": "mothers_day2025_decoration_tier1",
    "item_type": "decoration",
    "tier": 1,
    "tags_include": ["31_mothers_day2025"],
    "tags_exclude": ["no_gacha"]
  },
  {
    "id": "mothers_day2025_decoration_tier2",
    "item_type": "decoration",
    "tier": 2,
    "tags_include": ["31_mothers_day2025"],
    "tags_exclude": ["no_gacha"]
  },
  {
    "id": "mothers_day2025_decoration_tier3",
    "item_type": "decoration",
    "tier": 3,
    "tags_include": ["31_mothers_day2025"],
    "tags_exclude": ["no_gacha"]
  },
  {
    "id": "melon_season_decoration_tier1",
    "item_type": "decoration",
    "tier": 1,
    "tags_include": ["32_melon_season"],
    "tags_exclude": ["no_gacha"]
  },
  {
    "id": "melon_season_decoration_tier2",
    "item_type": "decoration",
    "tier": 2,
    "tags_include": ["32_melon_season"],
    "tags_exclude": ["no_gacha"]
  },
  {
    "id": "melon_season_decoration_tier3",
    "item_type": "decoration",
    "tier": 3,
    "tags_include": ["32_melon_season"],
    "tags_exclude": ["no_gacha"]
  },
  {
    "id": "tanabata_decoration_tier1",
    "item_type": "decoration",
    "tier": 1,
    "tags_include": ["33_tanabata"],
    "tags_exclude": ["no_gacha"]
  },
  {
    "id": "tanabata_decoration_tier2",
    "item_type": "decoration",
    "tier": 2,
    "tags_include": ["33_tanabata"],
    "tags_exclude": ["no_gacha"]
  },
  {
    "id": "tanabata_decoration_tier3",
    "item_type": "decoration",
    "tier": 3,
    "tags_include": ["33_tanabata"],
    "tags_exclude": ["no_gacha"]
  },
  {
    "id": "kakigori_decoration_tier1",
    "item_type": "decoration",
    "tier": 1,
    "tags_include": ["34_kakigori"],
    "tags_exclude": ["no_gacha"]
  },
  {
    "id": "kakigori_decoration_tier2",
    "item_type": "decoration",
    "tier": 2,
    "tags_include": ["34_kakigori"],
    "tags_exclude": ["no_gacha"]
  },
  {
    "id": "kakigori_decoration_tier3",
    "item_type": "decoration",
    "tier": 3,
    "tags_include": ["34_kakigori"],
    "tags_exclude": ["no_gacha"]
  },
  {
    "id": "moonviewing2025_decoration_tier1",
    "item_type": "decoration",
    "tier": 1,
    "tags_include": ["35_moonviewing2025"],
    "tags_exclude": ["no_gacha"]
  },
  {
    "id": "moonviewing2025_decoration_tier2",
    "item_type": "decoration",
    "tier": 2,
    "tags_include": ["35_moonviewing2025"],
    "tags_exclude": ["no_gacha"]
  },
  {
    "id": "moonviewing2025_decoration_tier3",
    "item_type": "decoration",
    "tier": 3,
    "tags_include": ["35_moonviewing2025"],
    "tags_exclude": ["no_gacha"]
  },
  {
    "id": "magicalbooks_decoration_tier1",
    "item_type": "decoration",
    "tier": 1,
    "tags_include": ["36_magicalbooks"],
    "tags_exclude": ["no_gacha"]
  },
  {
    "id": "magicalbooks_decoration_tier2",
    "item_type": "decoration",
    "tier": 2,
    "tags_include": ["36_magicalbooks"],
    "tags_exclude": ["no_gacha"]
  },
  {
    "id": "magicalbooks_decoration_tier3",
    "item_type": "decoration",
    "tier": 3,
    "tags_include": ["36_magicalbooks"],
    "tags_exclude": ["no_gacha"]
  },
  {
    "id": "taste_autumn_decoration_tier1",
    "item_type": "decoration",
    "tier": 1,
    "tags_include": ["37_taste_autumn"],
    "tags_exclude": ["no_gacha"]
  },
  {
    "id": "taste_autumn_decoration_tier2",
    "item_type": "decoration",
    "tier": 2,
    "tags_include": ["37_taste_autumn"],
    "tags_exclude": ["no_gacha"]
  },
  {
    "id": "taste_autumn_decoration_tier3",
    "item_type": "decoration",
    "tier": 3,
    "tags_include": ["37_taste_autumn"],
    "tags_exclude": ["no_gacha"]
  },
  {
    "id": "winter_candle_decoration_tier1",
    "item_type": "decoration",
    "tier": 1,
    "tags_include": ["38_winter_candle"],
    "tags_exclude": ["no_gacha"]
  },
  {
    "id": "winter_candle_decoration_tier2",
    "item_type": "decoration",
    "tier": 2,
    "tags_include": ["38_winter_candle"],
    "tags_exclude": ["no_gacha"]
  },
  {
    "id": "winter_candle_decoration_tier3",
    "item_type": "decoration",
    "tier": 3,
    "tags_include": ["38_winter_candle"],
    "tags_exclude": ["no_gacha"]
  },
  {
    "id": "ice_queens_castle_decoration_tier1",
    "item_type": "decoration",
    "tier": 1,
    "tags_include": ["39_ice_queens_castle"],
    "tags_exclude": ["no_gacha"]
  },
  {
    "id": "ice_queens_castle_decoration_tier2",
    "item_type": "decoration",
    "tier": 2,
    "tags_include": ["39_ice_queens_castle"],
    "tags_exclude": ["no_gacha"]
  },
  {
    "id": "ice_queens_castle_decoration_tier3",
    "item_type": "decoration",
    "tier": 3,
    "tags_include": ["39_ice_queens_castle"],
    "tags_exclude": ["no_gacha"]
  },
  {
    "id": "artisan_chocolatier_decoration_tier1",
    "item_type": "decoration",
    "tier": 1,
    "tags_include": ["40_artisan_chocolatier"],
    "tags_exclude": ["no_gacha"]
  },
  {
    "id": "artisan_chocolatier_decoration_tier2",
    "item_type": "decoration",
    "tier": 2,
    "tags_include": ["40_artisan_chocolatier"],
    "tags_exclude": ["no_gacha"]
  },
  {
    "id": "artisan_chocolatier_decoration_tier3",
    "item_type": "decoration",
    "tier": 3,
    "tags_include": ["40_artisan_chocolatier"],
    "tags_exclude": ["no_gacha"]
  },
  {
    "id": "valentine_day_decoration_tier1",
    "item_type": "decoration",
    "tier": 1,
    "tags_include": ["41_valentine_day"],
    "tags_exclude": ["no_gacha"]
  },
  {
    "id": "valentine_day_decoration_tier2",
    "item_type": "decoration",
    "tier": 2,
    "tags_include": ["41_valentine_day"],
    "tags_exclude": ["no_gacha"]
  },
  {
    "id": "valentine_day_decoration_tier3",
    "item_type": "decoration",
    "tier": 3,
    "tags_include": ["41_valentine_day"],
    "tags_exclude": ["no_gacha"]
  },
  {
    "id": "spring_tea_party_decoration_tier1",
    "item_type": "decoration",
    "tier": 1,
    "tags_include": ["42_spring_tea_party"],
    "tags_exclude": ["no_gacha"]
  },
  {
    "id": "spring_tea_party_decoration_tier2",
    "item_type": "decoration",
    "tier": 2,
    "tags_include": ["42_spring_tea_party"],
    "tags_exclude": ["no_gacha"]
  },
  {
    "id": "spring_tea_party_decoration_tier3",
    "item_type": "decoration",
    "tier": 3,
    "tags_include": ["42_spring_tea_party"],
    "tags_exclude": ["no_gacha"]
  },
  {
    "id": "easter_egg_hunt_decoration_tier1",
    "item_type": "decoration",
    "tier": 1,
    "tags_include": ["43_easter_egg_hunt"],
    "tags_exclude": ["no_gacha"]
  },
  {
    "id": "easter_egg_hunt_decoration_tier2",
    "item_type": "decoration",
    "tier": 2,
    "tags_include": ["43_easter_egg_hunt"],
    "tags_exclude": ["no_gacha"]
  },
  {
    "id": "easter_egg_hunt_decoration_tier3",
    "item_type": "decoration",
    "tier": 3,
    "tags_include": ["43_easter_egg_hunt"],
    "tags_exclude": ["no_gacha"]
  },
  {
    "id": "golden_week_decoration_tier1",
    "item_type": "decoration",
    "tier": 1,
    "tags_include": ["44_golden_week"],
    "tags_exclude": ["no_gacha"]
  },
  {
    "id": "golden_week_decoration_tier2",
    "item_type": "decoration",
    "tier": 2,
    "tags_include": ["44_golden_week"],
    "tags_exclude": ["no_gacha"]
  },
  {
    "id": "golden_week_decoration_tier3",
    "item_type": "decoration",
    "tier": 3,
    "tags_include": ["44_golden_week"],
    "tags_exclude": ["no_gacha"]
  },
  {
    "id": "rainyseason_bookcafe_decoration_tier1",
    "item_type": "decoration",
    "tier": 1,
    "tags_include": ["45_rainyseason_bookcafe"],
    "tags_exclude": ["no_gacha"]
  },
  {
    "id": "rainyseason_bookcafe_decoration_tier2",
    "item_type": "decoration",
    "tier": 2,
    "tags_include": ["45_rainyseason_bookcafe"],
    "tags_exclude": ["no_gacha"]
  },
  {
    "id": "rainyseason_bookcafe_decoration_tier3",
    "item_type": "decoration",
    "tier": 3,
    "tags_include": ["45_rainyseason_bookcafe"],
    "tags_exclude": ["no_gacha"]
  },
  {
    "id": "tropical_island_vacation_decoration_tier1",
    "item_type": "decoration",
    "tier": 1,
    "tags_include": ["46_tropical_island_vacation"],
    "tags_exclude": ["no_gacha"]
  },
  {
    "id": "tropical_island_vacation_decoration_tier2",
    "item_type": "decoration",
    "tier": 2,
    "tags_include": ["46_tropical_island_vacation"],
    "tags_exclude": ["no_gacha"]
  },
  {
    "id": "tropical_island_vacation_decoration_tier3",
    "item_type": "decoration",
    "tier": 3,
    "tags_include": ["46_tropical_island_vacation"],
    "tags_exclude": ["no_gacha"]
  },
  {
    "id": "seashell_decoration_tier1",
    "item_type": "decoration",
    "tier": 1,
    "tags_include": ["47_seashell"],
    "tags_exclude": ["no_gacha"]
  },
  {
    "id": "seashell_decoration_tier2",
    "item_type": "decoration",
    "tier": 2,
    "tags_include": ["47_seashell"],
    "tags_exclude": ["no_gacha"]
  },
  {
    "id": "seashell_decoration_tier3",
    "item_type": "decoration",
    "tier": 3,
    "tags_include": ["47_seashell"],
    "tags_exclude": ["no_gacha"]
  },
  {
    "id": "early_autumn_picnic_decoration_tier1",
    "item_type": "decoration",
    "tier": 1,
    "tags_include": ["48_early_autumn_picnic"],
    "tags_exclude": ["no_gacha"]
  },
  {
    "id": "early_autumn_picnic_decoration_tier2",
    "item_type": "decoration",
    "tier": 2,
    "tags_include": ["48_early_autumn_picnic"],
    "tags_exclude": ["no_gacha"]
  },
  {
    "id": "early_autumn_picnic_decoration_tier3",
    "item_type": "decoration",
    "tier": 3,
    "tags_include": ["48_early_autumn_picnic"],
    "tags_exclude": ["no_gacha"]
  },
  {
    "id": "pumpkin_farm_decoration_tier1",
    "item_type": "decoration",
    "tier": 1,
    "tags_include": ["49_pumpkin_farm"],
    "tags_exclude": ["no_gacha"]
  },
  {
    "id": "pumpkin_farm_decoration_tier2",
    "item_type": "decoration",
    "tier": 2,
    "tags_include": ["49_pumpkin_farm"],
    "tags_exclude": ["no_gacha"]
  },
  {
    "id": "pumpkin_farm_decoration_tier3",
    "item_type": "decoration",
    "tier": 3,
    "tags_include": ["49_pumpkin_farm"],
    "tags_exclude": ["no_gacha"]
  }
]
